 <div class="login-box reset-password-wrapper">
   <h1 class="login-page-title accent-text">{{'RESET_YOUR_PASSWORD' | dictionary }}</h1>
   <div class="form-group">
     <small class="form-text text-center">
       {{'PASSWORD_REQUIREMENTS' | dictionary}}
     </small>
     <small class="form-text text-center">
       {{'PASSWORD_CAN_NOT_BE_ANY_OF_LAST' | dictionary}}
     </small>
     <small class="form-text text-center">
       {{'DAY_HAVE_PASSED_SINCE_YOU_CHANGED_PASSWORD' | dictionary}}
     </small>
   </div>

   <div class="pt-0 pb-0" style="padding:0;">
     <form class="login-block" (ngSubmit)="submit()">
       <div class="m-portlet__body">
         <div class="input-wrapper">
           <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="userProfile.Password"
                  class="form-control home-login-input-text" name="username"
                  placeholder="{{'NEW_PASSWORD' | dictionary}}">
           <i class="fas icon cursor-pointer eye-bg"
              [pTooltip]="(!showPassword ? 'SHOW_PASSWORD' : 'HIDE_PASSWORD' ) | dictionary"
              [ngClass]=" {'fa-eye' : !showPassword, 'fa-eye-slash' : showPassword }"
              (click)="showPassword = !showPassword"></i>
         </div>

         <div class="input-wrapper">
           <input [type]="showConfirmPassword ? 'text' : 'password'" [(ngModel)]="userProfile.ConfirmPassword"    (paste)="preventPaste($event)"
                  class="form-control home-login-input-text" name="username"
                  aria-describedby="emailHelp" placeholder="{{'CONFIRM_PASSWORD' | dictionary}}">
           <i class="fas icon cursor-pointer eye-bg"
              [pTooltip]="(!showConfirmPassword ? 'SHOW_PASSWORD' : 'HIDE_PASSWORD' ) | dictionary"
              [ngClass]=" {'fa-eye' : !showConfirmPassword, 'fa-eye-slash' : showConfirmPassword }"
              (click)="showConfirmPassword = !showConfirmPassword"></i>
         </div>

         <div class="actions-wrapper">
           <button
             type="submit"
             class="button-1">
             {{'SUBMIT' | dictionary}}
           </button>
           <button (click)="cancel()"
                   class="button-1">
             {{'CANCEL' | dictionary}}
           </button>
         </div>

       </div>
     </form>

   </div>
 </div>


 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>

 <app-pop-up-dialog [Message]="successMessage" [Display]="displaySuccessMessage" (DisplayBack)="navigateHome()">
 </app-pop-up-dialog>

